/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ITumorBoardMember } from 'app/shared/model/tumor-board-member.model';
import { ITumorBoardOccurrence } from 'app/shared/model/tumor-board-occurrence.model';
import { InvitationStatus } from 'app/shared/model/enumerations/invitation-status.model';

export interface ITumorBoardOccurrenceParticipant {
  id?: string;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  invitationStatus?: keyof typeof InvitationStatus | null;
  participant?: ITumorBoardMember | null;
  occurrence?: ITumorBoardOccurrence | null;
}

export const defaultValue: Readonly<ITumorBoardOccurrenceParticipant> = {
  active: false,
};
